package com.downdogapp.client.controllers

actual class SignInViewControllerHelper actual constructor(vc: SignInViewController) {

  actual val isAppleSignInAvailable = true
  actual fun signInWithGoogle() {}
  actual fun signInWithFacebook() {}
  actual fun signInWithApple() {}
}
